import { MessageTypes } from '@/enums/apiEnums.ts';
import { MessageTypesUI } from '@/enums/viewEnums.ts';
import { WebSocketMessage } from '@/providers/WebSocketProvider/WebSocketProvider.tsx';
import { useDialogsStore } from '@/store/useDialogsStore.ts';
import { useWebSocketStore } from '@/store/useWebSocketStore.ts';
import { helpers } from '@/helpers.ts';
import { Toast } from '@/components/Toast/Toast.tsx';
import { routes } from '@/navigation/routes.tsx';

export const handleMessageIncoming = (ctxData: WebSocketMessage) => {
  const { appendToTopDialogWS, setHasUnreadEvents } =
    useDialogsStore.getState();
  const { setLastEvents } = useWebSocketStore.getState();

  appendToTopDialogWS(ctxData?.message_incoming_event);
  setLastEvents({ lastMessage: ctxData.message_incoming_event });
  setHasUnreadEvents(true);

  if (
    ctxData.message_incoming_event?.message.type &&
    ctxData.message_incoming_event?.message.type === MessageTypes.TYPE_MATCH
  ) {
    helpers.toast({
      id: MessageTypesUI.TYPE_MATCH,
      content: (
        <Toast
          type={MessageTypesUI.TYPE_MATCH}
          contact={ctxData.message_incoming_event?.contact}
        />
      ),
      exclude: [routes.search] // match toast will not be shown on match action, popup will be
    });
  }

  if (
    ctxData.message_incoming_event?.message.type &&
    ctxData.message_incoming_event?.message.type ===
      MessageTypes.TYPE_ICEBREAKER_GIFT
  ) {
    helpers.toast({
      id: MessageTypesUI.TYPE_GIFT,
      content: (
        <Toast
          type={MessageTypesUI.TYPE_GIFT}
          contact={ctxData.message_incoming_event?.contact}
        />
      )
    });
  }
};
